module.exports = __webpack_public_path__ + "static/logo-white-7449dd5f4f976ebfc0a0d1216b6c772b.svg";